import { render, staticRenderFns } from "./bankCard.vue?vue&type=template&id=d38c0cc8&scoped=true&"
import script from "./bankCard.vue?vue&type=script&lang=js&"
export * from "./bankCard.vue?vue&type=script&lang=js&"
import style0 from "./bankCard.vue?vue&type=style&index=0&id=d38c0cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38c0cc8",
  null
  
)

export default component.exports